import { HYDRATE_HASHED_STATE, SAVE_HASHED_STATE } from 'js/constants/actionTypes';
import { set } from 'lodash';

const initialState = {
  data: {},
  hash: '',
};

function hydrateState(state, action) {
  const {
    payload: { hashedState },
  } = action;
  set(state, 'data', JSON.parse(atob(hashedState)));
  return state;
}

function saveState(state, action) {
  const {
    payload: { path, value },
  } = action;
  set(state, 'data.' + path, value);
  set(state, 'hash', btoa(JSON.stringify(state.data)));
  return { ...state };
}

export const hashedState = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_HASHED_STATE:
      return saveState(state, action);
    case HYDRATE_HASHED_STATE:
      return hydrateState(state, action);
  }
  return state;
};
